// extracted by mini-css-extract-plugin
module.exports = {"root":"Tabs_root__85xFA","tab":"Tabs_tab__NBxlF","tabActive":"Tabs_tabActive__2qocO"};